export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026年全球体育赛事精彩回顾：那些激动人心的瞬间',
    summary: '回顾2026年上半年全球体育赛事的精彩瞬间，从世界杯到奥运会预选赛，每一场比赛都令人热血沸腾。',
    content: `<p>2026年是体育迷的盛宴之年。从年初的世界杯预选赛到各大洲际杯赛，全球体育赛事精彩纷呈。</p>
<h3>世界杯预选赛战况激烈</h3>
<p>亚洲区预选赛进入白热化阶段，各支球队为了世界杯入场券奋力拼搏。中国队在本轮预选赛中表现出色，展现出令人瞩目的进步和团队凝聚力。</p>
<p>欧洲区预选赛同样精彩，传统强队纷纷展现出强大的统治力，而一些黑马球队的崛起也让比赛充满了悬念和看点。</p>
<h3>NBA季后赛精彩对决</h3>
<p>NBA季后赛如火如荼地进行中，东西部决赛的对阵让人目不暇接。球星们的精彩表现成为球迷们热议的话题，每一场比赛都充满了戏剧性和观赏性。</p>
<h3>网球大满贯赛事回顾</h3>
<p>法网公开赛在罗兰·加洛斯激情上演，红土场上的较量精彩纷呈。新生代选手的崛起为网坛注入了新的活力，而老将们的坚守同样令人感动。</p>
<p>展望下半年，更多精彩赛事即将登场，让我们共同期待更多激动人心的体育时刻！</p>`,
    category: 'tiyu',
    categoryName: '体育赛事',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20filled%20with%20passionate%20fans%2C%20golden%20hour%20lighting%2C%20athletic%20competition%20atmosphere%2C%20dramatic%20moment%2C%20warm%20amber%20tones%2C%20professional%20sports%20photography&width=1200&height=675&seq=article-sports-01&orientation=landscape',
    author: '乐鱼体育编辑部',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['体育赛事', '世界杯', 'NBA', '网球'],
  },
  {
    id: 'article-2',
    title: '电子竞技产业2026发展报告：新机遇与新挑战',
    summary: '电子竞技产业持续高速发展，2026年市场规模再创新高。本文将深入分析电竞产业的最新趋势与发展方向。',
    content: `<p>随着数字经济的蓬勃发展，电子竞技产业在2026年迎来了新的发展高峰。据权威机构统计，全球电竞市场规模已突破200亿美元大关。</p>
<h3>市场规模持续扩大</h3>
<p>2026年全球电竞观众数量预计将达到6.5亿人，其中核心电竞爱好者超过3亿。中国作为全球最大的电竞市场，继续引领行业发展。</p>
<h3>主流赛事影响力提升</h3>
<p>英雄联盟全球总决赛、DOTA2国际邀请赛等顶级赛事的关注度持续攀升。2026年新增的多项国际赛事为选手提供了更多展示舞台。</p>
<h3>技术创新驱动变革</h3>
<p>VR/AR技术在电竞领域的应用日益成熟，为观众带来了全新的观赛体验。人工智能辅助训练系统也在职业战队中得到广泛应用。</p>
<p>展望未来，电竞产业将继续保持强劲增长势头，产业链各环节都将迎来新的发展机遇。</p>`,
    category: 'dianjing',
    categoryName: '电子竞技',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20tournament%20arena%20with%20massive%20LED%20screens%2C%20packed%20audience%2C%20dramatic%20stage%20lighting%20in%20warm%20golden%20tones%2C%20competitive%20gaming%20atmosphere&width=1200&height=675&seq=article-esports-01&orientation=landscape',
    author: '乐鱼电竞频道',
    date: '2026-08-03',
    readTime: '6分钟',
    tags: ['电子竞技', '产业报告', '电竞赛事', '游戏产业'],
  },
  {
    id: 'article-3',
    title: '高清直播技术革新：如何打造极致的观看体验',
    summary: '随着5G技术和超高清编码技术的成熟，高清直播体验达到了全新高度。本文带您了解背后的技术革新。',
    content: `<p>在数字化浪潮的推动下，高清直播技术正经历着前所未有的革新。从4K到8K，从传统编码到AI增强，直播体验不断提升。</p>
<h3>5G赋能超高清直播</h3>
<p>5G网络的全面商用为超高清直播提供了坚实的技术基础。低延迟、高带宽的特性使得4K甚至8K直播成为可能，观众可以享受到更加细腻流畅的画面。</p>
<h3>AI技术提升画质</h3>
<p>人工智能技术在视频增强领域的应用取得了突破性进展。AI超分辨率技术可以将低分辨率画面实时提升至高分辨率，即使在网络条件不佳的情况下也能保证观看体验。</p>
<h3>多视角互动直播</h3>
<p>新一代直播技术支持多视角自由切换，观众可以根据自己的喜好选择不同的观看角度。这种互动式的观看体验大大提升了用户的参与感。</p>
<p>乐鱼平台始终致力于为用户提供最佳的直播体验，持续投入技术研发，确保每一位用户都能享受到流畅、高清的直播内容。</p>`,
    category: 'zhibo',
    categoryName: '高清直播',
    image: 'https://readdy.ai/api/search-image?query=Modern%20broadcast%20control%20room%20with%20multiple%20high%20definition%20monitors%2C%20professional%20video%20equipment%2C%20warm%20ambient%20lighting%2C%20clean%20technical%20aesthetic%2C%20golden%20and%20cream%20tones&width=1200&height=675&seq=article-live-01&orientation=landscape',
    author: '乐鱼技术团队',
    date: '2026-08-05',
    readTime: '7分钟',
    tags: ['高清直播', '5G技术', 'AI增强', '视频技术'],
  },
  {
    id: 'article-4',
    title: '娱乐内容新趋势：2026年用户偏好分析',
    summary: '了解2026年用户最喜爱的娱乐内容类型，把握行业最新趋势，为用户提供更优质的内容服务。',
    content: `<p>2026年，娱乐内容消费呈现出多元化和个性化的新趋势。用户对于内容品质的要求不断提高，互动性和沉浸感成为新的关注焦点。</p>
<h3>短视频内容持续火爆</h3>
<p>短视频仍然是用户最喜爱的内容形式之一。精品化、系列化的短视频内容越来越受到用户的青睐，创作者也在不断提升内容质量。</p>
<h3>互动式娱乐体验崛起</h3>
<p>互动式内容，如互动剧、互动游戏等，正在成为新的增长点。用户不再满足于被动观看，而是希望能够参与到内容创作和走向决定中。</p>
<h3>社交+娱乐深度融合</h3>
<p>社交元素与娱乐内容的结合日益紧密。用户希望在观看内容的同时能够与朋友互动、分享观点，这种社交化的娱乐体验正在成为主流。</p>
<p>乐鱼平台紧跟行业趋势，不断丰富内容形态，为用户打造更加多元化的娱乐体验。</p>`,
    category: 'yule',
    categoryName: '娱乐天地',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20screen%20and%20comfortable%20seating%2C%20warm%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20premium%20lifestyle%2C%20golden%20hour%20tones&width=1200&height=675&seq=article-entertain-01&orientation=landscape',
    author: '乐鱼娱乐频道',
    date: '2026-08-06',
    readTime: '5分钟',
    tags: ['娱乐趋势', '用户偏好', '互动体验', '内容消费'],
  },
  {
    id: 'article-5',
    title: '足球赛事观赛指南：2026年不可错过的重磅对决',
    summary: '2026年足球赛事精彩纷呈，从欧洲五大联赛到洲际杯赛，我们为您整理了最值得关注的重磅对决。',
    content: `<p>2026年足球赛季迎来了多场令人期待的重磅对决。无论是欧洲顶级联赛还是国际赛事，精彩程度都令人期待。</p>
<h3>欧洲五大联赛看点</h3>
<p>英超联赛的争冠形势扑朔迷离，多支球队实力相当。西甲联赛中，传统豪门的对决依然是球迷关注的焦点。德甲、意甲和法甲同样精彩，各队的引援和战术调整让新赛季充满了变数。</p>
<h3>欧冠赛场激战正酣</h3>
<p>欧洲冠军联赛进入淘汰赛阶段后，每一场比赛都不容错过。顶级豪门之间的较量不仅是实力的对决，更是战术和意志的比拼。</p>
<h3>国家队赛事展望</h3>
<p>各支国家队为即将到来的大赛积极备战，友谊赛和预选赛中涌现出不少新星。年轻球员的崛起为国家队注入了新的活力。</p>
<p>关注乐鱼体育频道，获取最新赛事资讯和深度分析，不错过每一场精彩对决！</p>`,
    category: 'tiyu',
    categoryName: '体育赛事',
    image: 'https://readdy.ai/api/search-image?query=Professional%20football%20match%20in%20a%20packed%20stadium%20during%20golden%20hour%2C%20players%20in%20action%2C%20dramatic%20lighting%2C%20passionate%20atmosphere%2C%20warm%20amber%20tones%2C%20sports%20photography&width=1200&height=675&seq=article-football-01&orientation=landscape',
    author: '乐鱼体育编辑部',
    date: '2026-08-07',
    readTime: '6分钟',
    tags: ['足球', '欧冠', '五大联赛', '观赛指南'],
  },
  {
    id: 'article-6',
    title: '平台安全指南：如何保障您的账户与信息安全',
    summary: '账户安全是每位用户最关心的话题。本文详细介绍平台的安全保障措施以及用户在日常生活中应注意的安全事项。',
    content: `<p>在数字化时代，账户安全至关重要。乐鱼平台始终将用户的安全放在首位，建立了多层次的安全防护体系。</p>
<h3>平台安全保障措施</h3>
<p>乐鱼平台采用业界领先的加密技术，确保用户数据传输和存储的安全。多重身份验证机制为账户提供额外保护，实时风险监控系统能够及时发现并阻止异常操作。</p>
<h3>用户安全建议</h3>
<p>建议用户设置强密码，定期更换密码，不要在不同平台使用相同密码。开启二次验证功能可以大大提升账户安全性。</p>
<h3>防范网络诈骗</h3>
<p>警惕假冒平台客服的诈骗行为，乐鱼官方不会通过非官方渠道索取您的账户信息和验证码。如遇可疑情况，请立即联系官方客服核实。</p>
<p>安全无小事，乐鱼与您共同守护账户安全！</p>`,
    category: 'huodong',
    categoryName: '优惠活动',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20concept%20with%20shield%20icon%20on%20digital%20background%2C%20warm%20golden%20accents%2C%20clean%20professional%20design%2C%20trustworthy%20atmosphere%2C%20soft%20lighting&width=1200&height=675&seq=article-security-01&orientation=landscape',
    author: '乐鱼安全团队',
    date: '2026-08-02',
    readTime: '5分钟',
    tags: ['安全指南', '账户安全', '网络安全', '防诈骗'],
  },
];

export const getArticleById = (id: string) => {
  return articles.find((article) => article.id === id) || articles[0];
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getLatestArticles = (count: number = 5) => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};